import React, { useState, useEffect, Suspense, lazy } from 'react';
import { getDashboardRole } from './utils/accountType';
import {
  BrowserRouter as Router,
  Route,
  Switch,
  RouteProps,
  Redirect
} from 'react-router-dom';
import GiveLocation from './components/giveLocation/GiveLocation';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import ScrollToTop from './utils/scrollToTop';
import Navtab from '../src/components/navbar';
import Fallback from './components/loadingSpinner/loadingSpinner';
import { incrementInstallPopup } from './redux/actions';
import { useSelector, useDispatch } from 'react-redux';
import aboutPage from './pages/aboutPage';
import Dashboard from './pages/DashboardPage/dashboard';
import ManageStorePage from './pages/managestorepage/ManageStorePage';

import ManagepayPage from './pages/managepayPage/ManagepayPage';
import ManageWishlistPage from './pages/managewishlistpage/ManageWishlistPage';
import NeddieIntegrationPage from './pages/neddieIntegrationPage/NeddieIntegrationPage';
import HelpPage from './pages/helpPage/HelpPage';
import SettingsPage from './pages/DashboardPage/SettingsPage';
import DonorProfilePage from './pages/DashboardPage/DonorProfilePage';
const NpEventsPage = lazy(() => import('./pages/NpEventsPage/NpEventsPage'));
const Home = lazy(() => import('./pages/LandingPage'));
const NPProfile = lazy(
  () => import('./pages/nonprofitProfile/nonprofitProfile')
);

const DonorProfile = lazy(() => import('./pages/DonorProfile/donorProfile'));
const RecurringDonations = lazy(() => import('./pages/RecurringDonations/RecurringDonations'));
const MyFundraisersPage = lazy(() => import('./pages/myFundraisers/MyFundraisersPage'));
const CategoriesPage = lazy(() => import('./pages/CategoriesPage/CategoriesPage'));
const NonProfitCategoriesPage = lazy(() => import('./pages/NonProfitCategoriesPage/NonProfitCategoriesPage'));
const forgot_PW_page = lazy(() => import('./pages/LoginPage/forgot_PW_page'));
const PwResetPage = lazy(() => import('./pages/LoginPage/PwResetPage'));
const LoginPage = lazy(() => import('./pages/LoginPage/LoginPage'));
const Admin = lazy(() => import('./pages/adminPage/admin'));
const thankyouPage = lazy(() => import('./pages/donationPage/thankyouPage'));
const DonorReport = lazy(
  () => import('./pages/mobileDonorTracking/mobileDonorTracking')
);
const Find = lazy(() => import('./pages/findOrganization'));
const NoMatch = lazy(() => import('./pages/NoMatch'));
const ThankYou = lazy(() => import('./pages/signUpPage/thankYou'));
const Approve = lazy(() => import('./pages/approvePage/approve'));
const DonationPage = lazy(() => import('./pages/donationPage/donationPage'));
const NonprofitProfileDonation = lazy(() => import('./pages/nonprofitProfileDonation/nonprofitProfileDonation'));
const FundraiserDonationPage = lazy(() => import('./pages/fundraiserPage/FundraiserDonationPage'));
const Subscribe = lazy(() => import('./pages/subscribePage/subscribePage'));
const Confirm = lazy(() => import('./pages/confirmPage/confirm'));
const Search = lazy(() => import('./pages/searchPage/search'));
const StripeFailure = lazy(
  () => import('./pages/DashboardPage/managePay/failurePage')
);
const EventPage = lazy(() => import('./pages/EventPage/eventPage'));
const EventTicketOrderPage = lazy(
  () => import('./pages/EventPage/TicketOrderPage/eventTicketOrder')
);
const CompleteDonation = lazy(() => import('./pages/completeDonation/CompleteDonation'));
const CompleteDonationGoogleAndApple = lazy(() => import('./pages/completeDonation/CompleteDonationGoogleAndApple'));
const CompletePaypalDonation = lazy(() => import('./pages/paypalDonation/CompletePaypalDonation'));
const CompletePaypalRecurring = lazy(() => import('./pages/paypalDonation/CompletePaypalRecurring'));
const CanclePaypalDonation = lazy(() => import('./pages/paypalDonation/CanclePaypalDonation'));
const PaypalOnboardingComplete = lazy(() => import('./pages/paypalOnboardingComplete/PaypalOnboardingComplete'));
const EmbedDonationPage = lazy(() => import('./pages/embedDonation/EmbedDonationPage'));
const EmbedPaymentPopup = lazy(() => import('./pages/embedPaymentPopup/EmbedPaymentPopup'));
const EmbedPaymentPopupComplete = lazy(() => import('./pages/embedPaymentPopup/EmbedPaymentPopupComplete'));
const ConnectPayments = lazy(() => import('./pages/DashboardPage/connectPayments/ConnectPayments'));

const App = () => {
  const user = useSelector((state: any) => state.signin);
  const ProtectedRoute: React.FC<RouteProps & { allowedTypes?: string[] }> = ({ allowedTypes, ...props }) => {
    if (!user?._id) {
      return (
        <Route
          {...props}
          component={undefined}
          render={({ location }) => (
            <Redirect to={{ pathname: '/login', state: { from: location } }} />
          )}
        />
      );
    }
    // allowedTypes are dashboard roles (see utils/accountType), not raw orgTypes
    if (allowedTypes && !allowedTypes.includes(getDashboardRole(user.type) || '')) {
      return <Route {...props} component={undefined} render={() => <Redirect to='/dashboard' />} />;
    }
    return <Route {...props} />;
  };

  const [email, setEmail] = useState('');
  const dispatch = useDispatch();
  const reduxInstallPrompt = useSelector(
    (state: any) => state.displayInstallPopup
  );

  const dashAuth = (props: any) => {
    return <Dashboard {...props} />;
  };

  useEffect(() => {
    const isIos = () => {
      const userAgent = window.navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(userAgent);
    };

    const newNavigator: any = window.navigator;
    const isInStandaloneMode = () => newNavigator.standalone;

    if (isIos() && !isInStandaloneMode() && !(reduxInstallPrompt % 5)) { }
  }, []);

  useEffect(() => {
    dispatch(incrementInstallPopup());
  }, []);

  const [path, setPath] = useState(window.location.pathname);

  const enableCenterLayout = (path: string) => {
    // /fundraiser and /donation share /give's two-column donation layout CSS
    // (same np-profile-left/right-column split) — without also excluding them
    // here, #page-wrap's 1280px cap squeezes that layout on wide screens in a
    // way /give never does, even though the underlying CSS is identical.
    if (path.startsWith('/dashboard') || path === '/manage-pay' || path==='/profile'|| path === '/connect-payments'  || path === '/manage-wishlist' || path === '/manage-store' || path === '/neddie-integration' || path === '/help' || path === '/settings' || path.startsWith('/admin') || path.startsWith('/embed') || path.startsWith('/donor') || path.startsWith('/nonprofit-profile') || path.startsWith('/give') || path.startsWith('/fundraiser') || path.startsWith('/donation/') || path === '/recurring-donations' || path === '/my-fundraisers' || path === '/categories' || path === '/nonprofit-categories' || path.startsWith('/login') || path.startsWith('/signup') || path.startsWith('/reset') || path.startsWith('/forgot')) {
      return false;
    } else {
      return true;
    }
  };

  const showNavigation = (path: string) => {

    const params = new URLSearchParams(window.location.search);
    const wl = params.get('wl');
    // White label donation completion → no main header
    if (wl === '1') return false;

    if (path === '/search' || path === '/manage-pay' || path==='/profile'|| path === '/connect-payments' || path === '/manage-wishlist' || path === '/manage-store' || path === '/neddie-integration' || path === '/help' || path === '/settings' || path.startsWith('/embed') || path.startsWith('/dashboard') || path.startsWith('/donor') || path.startsWith('/nonprofit-profile') || path.startsWith('/give') || path === '/recurring-donations' || path === '/my-fundraisers' || path === '/categories' || path === '/nonprofit-categories') {
      return false;
    }
    return true;
  };

  return (
    <div>
      <Router>
        {showNavigation(path) ? (<Navtab class='light' background='trans' />) : null}
        <div id={enableCenterLayout(path) ? 'page-wrap' : ''}>
          <>
            <GiveLocation setPath={setPath} />
            <ScrollToTop>
              <Suspense fallback={<Fallback />}>
                <Switch>
                  <Route
                    exact
                    path='/search'
                    render={(props) => {
                      if (!props.location.state) {
                        return (
                          <Redirect to={{ pathname: '/search', state: { queryString: '', searchCategory: 'NonProfits' } }}/>
                        );
                      } else {
                        return <Search />;
                      }
                    }}
                  />
                  <Route exact path='/about' component={aboutPage} />
                  <ProtectedRoute exact path='/admin' component={Admin} />
                  <Route path='/complete-donation' component={CompleteDonation} />
                  <Route path='/complete-donation-google-apple' component={CompleteDonationGoogleAndApple} />
                  <Route path='/complete-paypal-donation' component={CompletePaypalDonation} />
                  <Route path='/complete-paypal-recurring' component={CompletePaypalRecurring} />
                  <Route path='/cancle-paypal-donation' component={CanclePaypalDonation} />
                  <Route path='/paypal-onboarding-complete' component={PaypalOnboardingComplete} />
                  <ProtectedRoute path='/connect-payments' component={ConnectPayments} allowedTypes={['nonprofit']} />
                  <Route exact path='/find' component={Find} />
                  <Route exact path='/login' render={(props) => <LoginPage {...props} mode='login' />} />
                  <Route exact path='/signup/:type?' render={(props) => (<LoginPage {...props} setEmail={setEmail} mode='signup' />)} />
                  <Route exact path='/signup-thankyou/:section' render={(props) => <ThankYou {...props} email={email} />} />
                  <Route exact path='/donation/:id/:campaign' component={DonationPage} />
                  <Route exact path='/donation/:slug' component={DonationPage} />
                  <Route exact path='/nonprofit-profile/:id/:campaign' component={NonprofitProfileDonation} />
                  <Route exact path='/give/:id' component={NonprofitProfileDonation} />
                  <Route exact path='/fundraiser/:id/:campaign' component={FundraiserDonationPage} />
                  <Route exact path='/fundraiser/:slug' component={FundraiserDonationPage} />
                  <Route exact path='/embed/donate/:id/:campaign?' component={EmbedDonationPage} />
                  <Route exact path='/embed/payment-popup' component={EmbedPaymentPopup} />
                  <Route exact path='/embed/payment-popup-complete' component={EmbedPaymentPopupComplete} />
                  <Route exact path='/thankyou/' component={thankyouPage} />
                  <Route exact path='/nonprofit/events/:id' component={NpEventsPage} />
                  <Route exact path='/nonprofit/:id' component={NPProfile} />
                  <ProtectedRoute exact path='/manage-pay' component={ManagepayPage} allowedTypes={['nonprofit']} />
                  <ProtectedRoute exact path='/manage-wishlist' component={ManageWishlistPage} allowedTypes={['nonprofit']} />
                  <ProtectedRoute exact path='/manage-store' component={ManageStorePage} allowedTypes={['nonprofit']} />
                  <ProtectedRoute exact path='/neddie-integration' component={NeddieIntegrationPage} allowedTypes={['nonprofit']} />
                  <ProtectedRoute exact path='/help' component={HelpPage} allowedTypes={['nonprofit']} />
                  <ProtectedRoute exact path='/settings' component={SettingsPage} allowedTypes={['nonprofit']} />
                  <ProtectedRoute exact path='/profile' component={DonorProfilePage} allowedTypes={['individual']} />
                  <Route exact path='/event/tickets' component={EventTicketOrderPage} />
                  <Route exact path='/event/:id' component={EventPage} />
                  <Route exact path='/donor/:id' component={DonorProfile} />
                  <ProtectedRoute exact path='/recurring-donations' component={RecurringDonations} allowedTypes={['individual']} />
                  <ProtectedRoute exact path='/my-fundraisers' component={MyFundraisersPage} allowedTypes={['individual']} />
                  <Route exact path='/categories' component={CategoriesPage} />
                  <Route exact path='/nonprofit-categories' component={NonProfitCategoriesPage} />
                  <Route exact path='/404' component={NoMatch} />
                  <Route exact path='/confirm/:type/:id' component={Confirm} />
                  <Route exact path='/approve/:type/:id/' component={Approve} />
                  <Route exact path='/' component={Home} />
                  <Route exact path='/subscribe' component={Subscribe} />
                  <Route exact path='/forgot' component={forgot_PW_page} />
                  <ProtectedRoute exact path='/dashboard' render={dashAuth} />
                  <ProtectedRoute exact path='/donationTracking' component={DonorReport} allowedTypes={['individual']} />
                  <ProtectedRoute exact path='/dashboard/:section/:error' component={StripeFailure} />
                  <ProtectedRoute exact path='/dashboard/:section' render={dashAuth} />
                  <Route exact path='/reset/:token' component={PwResetPage} />
                  <Route component={NoMatch} />
                </Switch>
              </Suspense>
            </ScrollToTop>
          </>
        </div>
      </Router>
    </div>
  );
};

export default App;
